"use client";
import React, { useState } from "react";
// import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid'
import Image from "next/image";
import Seemore from "../../../public/updated-home/car-service/seemore.svg";
import Seeless from "../../../public/updated-home/car-service/seeless.svg";
import Link from "next/link";
// console.log(MyData, 'sssss');
import style from "@/app/style/state.module.css";

const services = [
  {
    id: "#1",
    title: "Texas",
    desc: "Covering 50+ Routes Around the States",
    image: "updattexas",
    link: "/states/car-service-texas",
  },

  {
    id: "#3",
    title: "Illinois",
    desc: "Covering 60+ Routes Around the States",
    image: "updateIllinois",
    link: "/states/car-service-illinois",
  },

  {
    id: "#4",
    title: "California",
    desc: "Covering 40+ Routes Around the States",
    image: "updateoffcalifonia",
    link: "/states/car-service-california",
  },
  {
    id: "#3",
    title: "Massachusetts",
    desc: "Covering 70+ Routes Around the States",
    image: "updatemassachusetts",
    link: "/states/car-service-massachusetts",
  },

  {
    id: "#4",
    title: "Georgia",
    desc: "Covering 40+ Routes Around the States",
    image: "updatGeorgia",
    link: "/states/georgia-car-service",
  },
  
  {
    id: "#3",
    title: "Florida",
    desc: "Covering 60+ Routes Around the States",
    image: "updatFlorida",
    link: "/states/car-service-florida",
  },

  {
    id: "#4",
    title: "Connecticut",
    desc: "Covering 50+ Routes Around the States",
    image: "updatConnecticut",
    link: "/states/connecticut-car-service",
  },
  {
    id: "#3",
    title: "New York",
    desc: "Covering 60+ Routes Around the States",
    image: "updatNewYork",
    link: "/states/car-service-new-york",
  },

  // {
  //   id: "#4",
  //   title: "Washington",
  //   desc: "Covering 70+ Routes Around the States",
  //   image: "updatWashington",
  //   link: "#",
  // },

  {
    id: "#4",
    title: "New Jersey",
    desc: "Covering 40+ Routes Around the States",
    image: "updatNewJersey",
    link: "/states/car-service-new-jersey",
  },
  {
    id: "#4",
    title: "Pennsylvania",
    desc: "Covering 60+ Routes Around the States",
    image: "updatPennsylvania",
    link: "/states/pennsylvania-car-service",
  },
  {
    id: "#4",
    title: "Colorado",
    desc: "Covering 70+ Routes Around the States",
    image: "ColoradoMainPage",
    link: "/states/colorado-car-service",
  },
];

function discover() {
  const [viewAllServices, setViewAllServices] = useState(4);

  const HandleViewAllServies = () => {
    if (viewAllServices === 4) {
      setViewAllServices(services.length);
      console.log(viewAllServices);
    }

    if (viewAllServices === services.length) {
      setViewAllServices(4);
    }

    // if(viewAllServices === viewAllServices)
    // {
    // setViewAllServices(3)
    // console.log(viewAllServices)
    // }
    // console.log(viewAllServices)
  };

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div>
      <div className=" mb-10">
        <div className="mx-auto max-w-7xl ">
          {/* Content goes here */}
          <div className="mx-auto px-7  mt-4 sm:max-w-7xl  md:max-w-6xl    lg:max-w-7xl xl:text-center">
            <h2 className=" text-3xl  font-bold secondary">
              <span style={{ color: "#D5AF34" }}>
                {" "}
                Discover Prestige Ride:{" "}
              </span>
              <br />
              <span style={{ color: "#2B3252" }}>
                Your Nationwide Luxury Transportation Partner
              </span>
            </h2>

            <p className="updatedparapremu pt-3 mb-12 leading-7">
              In a world where convenience, luxury, and reliability are more
              sought after than ever, Prestige Ride stands as a beacon of
              excellence in the transportation industry. As a leader in offering
              luxurious and dependable black car services across
              all the states, we are your ideal partner for unparalleled luxury
              transport services. Let’s discuss in deeper to discover why
              Prestige Ride should be your first choice.{" "}
            </p>
          </div>
          {/* ============================================================================================== */}

          <div className="mx-auto max-w-7xl">
            <div className="grid px-7 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 ">
              {services?.slice(0, viewAllServices).map((server, index) => {
                return (
                  // <>
                  <Link href={server.link} onClick={scrollTop} key={index}>
                    <div
                      id={style.maincitysize}
                      className={style[server.image]}
                    >
                      <div className="    mt-1 text-white">
                        <div className="px-4 pt-24 ">
                          <h2 className=" flex   justify-start updatedheading text-white">
                            {server.title}
                          </h2>
                          <p className=" text-left updatedparapremu text-white">
                            {server.desc}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                  // </>
                );
              })}
            </div>
            <div className="flex justify-center mt-8">
              <button onClick={HandleViewAllServies} type="button" className="">
                {viewAllServices === 4 ? (
                  <Image src={Seemore} alt="see more" title="see more" />
                ) : (
                  <Image src={Seeless} alt="see more" title="see more" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default discover;
